<template>
  <div class="container container-md">
    <!-- 頁面內容 -->
    <section class="section-group pt-4">
      <div class="card p-4">
        <h3 class="page-title mb-2">{{ $t('Activitys.SendMessage.information') }}</h3>
        <hr class="divider" />
        <div class="page-content">
          <p class="mb-3">
            {{ $t('Activitys.SendMessage.activities') }}
            <router-link :to="{ name: 'eventList' }">{{ $t('Activitys.SendMessage.Activitylist') }}</router-link>{{ $t('Activitys.SendMessage.on') }}
          </p>
          <el-form
            :model="messageModel"
            ref="messageModel"
            :rules="activerules"
          >
            <el-form-item :label="$t('Activitys.SendMessage.ActivityName')" prop="title">
              <el-input v-model="messageModel.title"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Activitys.SendMessage.activityType')" prop="activityType">
              <el-checkbox-group v-model="messageModel.activityType">
                <el-checkbox
                  v-for="item in EventTypeList"
                  :key="item.id"
                  ::label="item.sgL_NewName"
                  >{{ item.sgL_NewName }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item :label="$t('Activitys.SendMessage.activityUrl')" prop="activityUrl">
              <el-input
                :placeholder="$t('Activitys.SendMessage.activityUrl')"
                v-model="messageModel.activityUrl"
              >
                <template slot="prepend">http://</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('Activitys.SendMessage.area')" prop="area">
              <div class="row">
                <div class="col-sm-12">
                  <el-select
                    v-model="messageModel.sgL_City"
                    clearable
                    :placeholder="$t('Activitys.SendMessage.sgL_City')"
                  >
                    <el-option
                      v-for="Area in EventCityList"
                      :key="Area.id"
                      ::label="Area.sgL_NewName"
                      :value="Area.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="messageModel.sgL_Area"
                    clearable
                    :placeholder="$t('Activitys.SendMessage.sgL_Area')"
                  >
                    <el-option
                      v-for="Area in EventAreaList"
                      :key="Area.id"
                      ::label="Area.sgL_NewName"
                      :value="Area.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('Activitys.SendMessage.sgL_Address')">
              <div class="row">
                <div class="col-sm-12">
                  <el-input
                    v-model="messageModel.sgL_Address"
                    :placeholder="$t('Activitys.SendMessage.placeholder')"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('Activitys.SendMessage.activityData')" prop="activityData">
              <el-date-picker
                v-model="messageModel.activityData"
                type="daterange"
                value-format="yyyy-MM-dd"
                :range-separator="$t('Activitys.SendMessage.msg')"
                :start-:placeholder="$t('Activitys.SendMessage.startdate')"
                :end-:placeholder="$t('Activitys.SendMessage.enddate')"
              ></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('Activitys.SendMessage.activityStartData')">
              <el-date-picker
                v-model="messageModel.activityStartData"
                type="daterange"
                value-format="yyyy-MM-dd"
                :range-separator="$t('Activitys.SendMessage.msg')"
                :start-:placeholder="$t('Activitys.SendMessage.startdate')"
                :end-:placeholder="$t('Activitys.SendMessage.enddate')"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="submitForm('messageModel')"
                class="btn btn-block btn-primary"
                >{{ $t('Activitys.SendMessage.submit') }}</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </section>
    <!-- ./頁面內容 -->
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      EventCityList: null,
      EventAreaList: null,
      EventTypeList: null,
      messageModel: {
        title: null,
        activityType: [],
        activityUrl: null,
        activityData: null,
        area: null,
        city: null,
        areas: null,
        sgL_City: null,
        sgL_Area: null,
        sgL_Address: null,
        activityStartData: null,
      },
      activerules: {
        title: [{ required: true, message: this.$t('Activitys.SendMessage.activerules.title'), trigger: "blur" }],
        activityType: [
          { required: true, message: this.$t('Activitys.SendMessage.activerules.activityType'), trigger: "change" },
        ],
        activityUrl: [
          { required: true, message: this.$t('Activitys.SendMessage.activerules.activityUrl'), trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    "messageModel.sgL_City": {
      handler: function (newvalue, oldvalue) {
        if (newvalue != null && newvalue >= 1) {
          this.getEventArea(newvalue);
          this.getEventTypeByidcityDesk(newvalue);
        }
      },
    },
    "messageModel.sgL_Area": {
      handler: function (newvalue, oldvalue) {
        if (newvalue != null && newvalue >= 1) {
          this.getEventTypeByidareaDesk(newvalue);
        }
      },
    },
     '$i18n.locale'(newval) {
      this.setActiverules();
      this.$refs['messageModel'].resetFields();

    },
  },
  created() {
    this.setActiverules();
    this.$store.dispatch("updateCurrentIndex", 3);
    this.$store.dispatch("getCommonTypeDesk", 40).then((res) => {
      this.EventTypeList = res; //活動類型
    });
    this.$store.dispatch("getCommonTypeDesk", 30).then((res) => {
      this.EventCityList = res; //城市
    });
  },
  methods: {
    setActiverules(){
      const that = this;
      this.activerules = {
        title: [{ required: true, message: that.$t('Activitys.SendMessage.activerules.title'), trigger: "blur" }],
        activityType: [
          { required: true, message: that.$t('Activitys.SendMessage.activerules.activityType'), trigger: "change" },
        ],
        activityUrl: [
          { required: true, message: that.$t('Activitys.SendMessage.activerules.activityUrl'), trigger: "blur" },
        ],
      };

    },
    submitForm(formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          let params = {
            title: this.messageModel.title,
            activityType: this.messageModel.activityType,
            activityData: this.messageModel.activityData,
            activityUrl: this.messageModel.activityUrl,
            area:
              this.messageModel.city +
              " " +
              this.messageModel.areas +
              " " +
              this.messageModel.sgL_Address,
            activityStartData: this.messageModel.activityStartData,
          };

          //添加
          this.$api.EventApi.sendEmail(params).then((result) => {
            if (result.data.success) {
             
              this.$router.push({ name: "eventsucces" });
            } else {
              Message({
                type: "error",
                message: "失敗",
              });
            }
          });
        } else {
          Message({
            type: "error",
            message: "請填寫必填數據",
          });
          return false;
        }
      });
    },
    getEventTypeByidcityDesk(id) {
      let params = {
        id: id,
      };
      let name = null;
      this.$api.EventApi.getEventTypeByidDesk(params).then((res) => {
        if (res.data.success) {
          this.messageModel.city = res.data.result.sgL_NewName;
        }
      });
    },
    getEventTypeByidareaDesk(id) {
      let params = {
        id: id,
      };
      this.$api.EventApi.getEventTypeByidDesk(params).then((res) => {
        if (res.data.success) {
          this.messageModel.areas = res.data.result.sgL_NewName;
        }
      });
    },
    getEventArea(PId) {
      let params = {
        SGL_TypeT: 30, //城市
        MaxResultCount: 100,
        SGL_ParentID: 1, //區域
        SGL_NewTypeId: PId,
      };
      this.$api.EventApi.GetEventTypeDesk(params).then((res) => {
        if (res.data.success) {
          this.EventAreaList = res.data.result.items;
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Activitys/SendMessage.vue